import { connect } from 'react-redux';
import HomeView from './components/HomeView';

import {
	share,
	checkMatch,
	spin,
	doClaim,
	refresh,
	claimClub,
	updateJackpot,
	updateWinnerJackpot,
	updateWinnerSemiJackpot,
} from 'authentication/actions';

const mapDispatchToProps = {
	share,
	checkMatch,
	spin,
	doClaim,
	refresh,
	claimClub,
	updateJackpot,
	updateWinnerJackpot,
	updateWinnerSemiJackpot,
};

const mapStateToProps = (state) => ({
	currentUser: state.currentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);
